var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheckCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.486 4.486 0 10 0s10 4.486 10 10-4.486 10-10 10S0 15.514 0 10Zm15.231-3.345a.8.8 0 0 0-1.225-1.029l-5.873 6.998-2.188-2.426a.8.8 0 1 0-1.188 1.071l2.804 3.11a.8.8 0 0 0 1.207-.022l6.463-7.702Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCheckCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-check-circle.bc25e5a01532d90ddd96a000e8f11d8f.svg";